var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLightsWarn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(5.3531 5)",
    width: 26,
    height: 26,
    fill: "#fff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "element/icon/24/light copy 4@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9238 0 0 .94719 -4.967 -5.0257)",
    clipPath: "url(#a)",
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.2 15.284-0.0014-1e-3c-0.172-0.1278-0.3533-0.2439-0.5422-0.3483l-7.6736-4.9284c-0.7762-0.52938-1.7169-0.83936-2.731-0.83936-2.6598 0-4.8158 2.1318-4.8158 4.7614 0 1.685 0.88596 3.1644 2.2217 4.0107l-8.1e-4 0.0012 7.8466 5.0204c0.1261 0.0896 0.2567 0.1731 0.3915 0.2505l0.0215 0.0137 7e-4 -1e-3c0.7048 0.3996 1.5207 0.6293 2.3914 0.6293 2.6598 0 4.8158-2.1318 4.8158-4.7614 0-1.5568-0.7559-2.9389-1.9244-3.8077z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.125 19.092c0 2.6296-2.156 4.7612-4.8156 4.7612-2.6597 0-4.8158-2.1316-4.8158-4.7612s2.1561-4.7614 4.8158-4.7614c2.6596 0 4.8156 2.1318 4.8156 4.7614z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.6864 5v5.8542c0 0.5169 0.72767 0.936 1.6251 0.936 0.8975 0 1.6249-0.4191 1.6249-0.936v-5.8542z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.656 20.459v4.1216h2v-4.1216zm2.0199 6.93v-1.3537h-2v1.3537z",
    fill: "#e34a4a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightsWarn);
export default __webpack_public_path__ + "static/media/icon-lights-warn.e07f5e884164e654a88ae96b57792c99.svg";
export { ForwardRef as ReactComponent };